var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"note"},[_c('div',{staticClass:"note__ico"},[_c('BaseSvg',{attrs:{"name":"ico-info"}})],1),_c('div',{staticClass:"note__text text"},[_vm._t("default",function(){return [_c('p',[_vm._v(_vm._s(_vm.value))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }